import { t } from '@avalara/bat-apps-shared/i18n';
import { SAlert, SBox, SCol, SRow } from '@avalara/skylab-sdk/react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import type { OfferPlanClientDetails } from '../../../../../types/offers';
import { formatPrice } from '../../../../shared/helpers';
import { embeddedViewRequested } from '../../../lib/helpers';
import { getOfferPlanPrice } from '../../../lib/offers';
import { selectIsNonAdmin, selectState } from '../../../selectors';
import { purchaseDeflectionWording } from '../../helpers';
import OfferBox from '../box';
import NextButton from './shared/next-button';
import SelectPlanButton from './shared/select-plan-button';
import { FixedWidthPlanWrapper } from './shared/styles';

type Props = {
  plans: Array<OfferPlanClientDetails>;
};

const AvataxSandboxPlanSelect = ({ plans }: Props) => {
  const [selectedPlanName, selectPlanName] = useState('');
  const isNonAdmin = useSelector(selectIsNonAdmin);
  const {
    account: { isLoggedIn },
  } = useSelector(selectState);

  useEffect(() => {
    if (plans.length) selectPlanName(plans[plans.length - 1].name); // default to last plan selected
  }, [plans]);

  return (
    <>
      {isLoggedIn && isNonAdmin && (
        <SAlert status='info' noDismiss={true} className='margin-all-sm'>
          <div>{purchaseDeflectionWording}</div>
        </SAlert>
      )}
      <OfferBox isEmbedded={embeddedViewRequested()} className='margin-all-sm pad-all-sm'>
        <SRow>
          <SCol>
            <p data-ref='buy.plan-select.avatax-sandbox.header-content' className='margin-top-sm text-lg'>
              {t('client.general.choose-how-much-avatax-sandbox-access-your-business-needs')}
            </p>
          </SCol>
        </SRow>

        <SRow>
          {plans?.map((plan) => (
            <SCol key={plan.name} span='auto' className='flex justify-content-center'>
              <FixedWidthPlanWrapper
                onClick={() => selectPlanName(plan.name)}
                selected={selectedPlanName === plan.name}
                disabled={isLoggedIn && isNonAdmin}
              >
                <SBox
                  data-ref={`buy.plan-select.avatax-sandbox.${plan.name}-container`}
                  className='margin-bottom-sm margin-top-xs text-center'
                >
                  <p data-ref='buy.plan-select.avatax-sandbox.product-item-name' className='text-lg'>
                    {plan.productItems?.[0].name}
                  </p>

                  <hr />
                  <p data-ref='buy.plan-select.avatax-sandbox.product-price' className='text-xxl'>
                    {formatPrice(getOfferPlanPrice(plan), 0)}
                  </p>
                  <hr />

                  <div
                    data-ref='buy.plan-select.avatax-sandbox.select-button-container'
                    className='pad-bottom-sm pad-top-xl'
                  >
                    <SelectPlanButton
                      isSelected={selectedPlanName === plan.name}
                      planName={plan.name}
                      disableButton={isLoggedIn && isNonAdmin}
                    />
                  </div>
                </SBox>
              </FixedWidthPlanWrapper>
            </SCol>
          ))}
        </SRow>

        <SRow>
          <SCol span='auto' className='flex align-items-center justify-content-end'>
            <NextButton selectedPlanName={selectedPlanName} disableButton={isLoggedIn && isNonAdmin} />
          </SCol>
        </SRow>
      </OfferBox>
    </>
  );
};

export default AvataxSandboxPlanSelect;
